import{hexToNumber as t}from"../../utils/encoding/fromHex.js";async function e(e){const n=await e.request({method:"eth_chainId"});return t(n)}export{e as getChainId};
